export const environment = {
  production: false,
  version: 'V1.0.1',
  apiUrl: 'https://member-admin-api.kga.in/',
  memberMobileApiUrl: 'https://member-api.kga.in/',
  posUrl: 'https://pos-admin-api.kga.in/',
  memberAdminUrl: 'https://member-admin-api.kga.in/',
  baseUrl: 'https://erp.kga.in/',
  posSaleUrl: 'https://pos-sale-api.kga.in/',
  loginUrl: 'https://erp.kga.in/',
};
